import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TrainingMaterialsListComponent} from './training-materials-list.component';
import {LoadingSpinnerModule} from '../loading/loading-spinner/loading-spinner.module';
import {FilePreviewModule} from '../file-preview/file-preview.module';

@NgModule({
    declarations: [
        TrainingMaterialsListComponent
    ],
    imports: [
        CommonModule,
        LoadingSpinnerModule,
        FilePreviewModule
    ],
    exports: [
        TrainingMaterialsListComponent
    ]
})
export class TrainingMaterialsListModule {
}

